import { render, staticRenderFns } from "./MpgsCardInput.vue?vue&type=template&id=7f8b89d4"
import script from "./MpgsCardInput.vue?vue&type=script&lang=js"
export * from "./MpgsCardInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports